import { kinks } from '@turf/turf';
import { latLngArrayToGeoJSON } from '@domains/turf';

export const polygonRefs: google.maps.Polygon[] = [];

/**
 * Quita vértices consecutivos repetidos y el cierre repetido del anillo. Los
 * polígonos guardados suelen traer el punto inicial repetido N veces, lo que
 * turf.kinks marcaría como autointersección aunque la forma esté bien.
 */
const dedupePath = (
  path: google.maps.LatLngLiteral[]
): google.maps.LatLngLiteral[] => {
  const cleaned: google.maps.LatLngLiteral[] = [];
  for (const point of path) {
    const last = cleaned[cleaned.length - 1];
    if (!last || last.lat !== point.lat || last.lng !== point.lng) {
      cleaned.push(point);
    }
  }
  while (
    cleaned.length > 1 &&
    cleaned[0].lat === cleaned[cleaned.length - 1].lat &&
    cleaned[0].lng === cleaned[cleaned.length - 1].lng
  ) {
    cleaned.pop();
  }
  return cleaned;
};

/**
 * Detecta si un polígono se corta a sí mismo (autointersección).
 *
 * Deduplica los vértices antes de evaluar (para no marcar como inválida una
 * forma correcta que solo trae puntos repetidos) y se apoya en turf.kinks.
 * Un polígono necesita al menos 4 vértices distintos para poder cruzarse
 * (un triángulo nunca lo hace). Cualquier error al construir la geometría se
 * trata como "no determinable" -> false, para no bloquear por datos incompletos.
 */
export const hasSelfIntersection = (
  path: google.maps.LatLngLiteral[]
): boolean => {
  if (!path) return false;
  const cleaned = dedupePath(path);
  if (cleaned.length < 4) return false;
  try {
    return kinks(latLngArrayToGeoJSON(cleaned)).features.length > 0;
  } catch {
    return false;
  }
};

/** Mensaje estándar mostrado cuando un polígono se autointersecta. */
export const SELF_INTERSECTION_MESSAGE =
  'El polígono se corta a sí mismo. Corrige la geometría antes de guardar.';
